/**
 * Hammer.js 手势识别配置常量
 */

/**
 * Pan 手势配置
 */
export const HAMMER_PAN_CONFIG = {
  THRESHOLD: 10 // 触发滑动的最小距离（像素）
}

/**
 * Press 手势配置
 */
export const HAMMER_PRESS_CONFIG = {
  TIME: 150, // 长按触发时间（毫秒）
  THRESHOLD: 30 // 长按允许的最大移动距离（像素） - 调大以提高灵敏度
}

/**
 * 录音取消配置
 */
export const RECORDING_CANCEL_CONFIG = {
  OFFSET_Y: -40 // 上划取消录音的阈值（像素）
}

/**
 * 录音时长配置
 */
export const RECORDING_DURATION_CONFIG = {
  MIN_DURATION: 1000 // 最小录音时长（毫秒）- 1秒
}

/**
 * Hammer.js 初始化延迟（毫秒）
 * 等待 DOM 完全渲染
 */
export const HAMMER_INIT_DELAY = 100

